import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDeposito } from '@app/modules/deposito/models/deposito.model';
import { IPreDeposito } from '@app/modules/deposito/models/pre_deposito.model';
import { DepositoService } from '@app/modules/deposito/services/deposito.service';
import { PreDepositoService } from '@app/modules/deposito/services/pre_deposito.service';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';
import { zip } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import {
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';
import { FastParceiroComponent } from '../fast-parceiro/fast-parceiro.component';

@Component({
  selector: 'app-fast-deposito',
  templateUrl: './fast-deposito.component.html',
  styleUrls: ['./fast-deposito.component.scss'],
  providers: [DepositoService, ParceiroService, PreDepositoService]
})
export class FastDepositoComponent implements AfterViewInit {
  @ViewChild('fastDeposito') fastDeposito: Dialog;
  @ViewChild(FastParceiroComponent)
  _fastParceiro: FastParceiroComponent<IDeposito>;

  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;

  viewInit = false;

  notRequired = true;

  // entity: IDeposito = {
  //   parceiro: {
  //     contatos: [],
  //     enderecos: []
  //   } as IParceiro
  // } as IDeposito;

  entity: IPreDeposito = {
    domain_id: this.tokenService.getDomain().id,
    deposito: { parceiro: {} }
  } as IPreDeposito;

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastDepositoComponent>,
    public entityService: DepositoService,
    private tokenService: TokenService,
    protected preDepositoService: PreDepositoService,
    private parceiroService: ParceiroService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA)
    private data: { entity: IPreDeposito }
  ) {}

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.deposito.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return (
      this.viewInit &&
      this._fastEndereco.form.valid &&
      this._fastParceiro.form.valid
    );
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.viewInit && this._fastParceiro.form.invalid)
      this._fastParceiro.form.markAllAsTouched();
    return this.viewInit && this._fastParceiro.form.invalid;
  }

  onSubmit(): void {
    var entity: IPreDeposito = Utils.clearObject<IPreDeposito>({
      ...this.entity,
      domain_id: this.tokenService.getDomain().id,
      deposito: {
        ...this.entity.deposito,
        parceiro: Utils.clearObject({
          ...this.entity.deposito.parceiro,
          ...this._fastParceiro.getValues(),
          enderecos: this._fastEndereco.getValues(),
          contatos: this._fastContato.getValues()
        })
      }
    } as IPreDeposito);
    entity.deposito.parceiro = Utils.trimAttributes(entity.deposito.parceiro);
    entity.deposito.parceiro = Utils.clearEmptyString(entity.deposito.parceiro);
    this.insert(entity);
  }

  insertPreCadastro(entity: IPreDeposito): void {
    this.preDepositoService.insert(entity).subscribe(
      precadastro => {
        this.matSnackBar.open('Depósito criado com sucesso.', 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-success']
        });
        this.dialogRef.close(precadastro);
      },
      (err: HttpErrorResponse) => this.displayError(err)
    );
  }

  insert(entity: IPreDeposito): void {
    var preCadastro = {
      domain_id: entity.domain_id,
      nome_razao_social:
        entity.deposito.parceiro.apelido_nome_fantasia &&
        entity.deposito.parceiro.apelido_nome_fantasia.length != 0
          ? entity.deposito.parceiro.apelido_nome_fantasia
          : entity.deposito.parceiro.nome_razao_social,
      observacao: this._fastParceiro.getObservacaoValue()
    } as IPreDeposito;
    if (entity.deposito.parceiro.cpf_cnpj) {
      if (entity.deposito.parceiro.id) {
        this.preDepositoService.insert(preCadastro).subscribe(
          precadastro => {
            zip(
              this.parceiroService.update({
                ...entity.deposito.parceiro
              }),
              this.entityService.insert({
                ...entity.deposito,
                id: entity.deposito.parceiro.id,
                domain_id: entity.domain_id,
                parceiro: undefined,
                pre_deposito_id: precadastro.id
              })
            )
              .pipe(
                mergeMap(([, deposito]) => {
                  return this.preDepositoService.getEntity(precadastro.id);
                })
              )
              .subscribe(
                precadastro => {
                  this.matSnackBar.open('Depósito criado com sucesso.', 'X', {
                    duration: 2000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['msg-success']
                  });
                  this.dialogRef.close(precadastro);
                },
                (err: HttpErrorResponse) => this.displayError(err)
              );
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
      } else {
        this.preDepositoService.insert(preCadastro).subscribe(
          precadastro => {
            this.parceiroService
              .insert({
                ...entity.deposito.parceiro,
                domain_id: this.tokenService.getDomain().id
              })
              .pipe(
                mergeMap(parceiro => {
                  return this.entityService.insert({
                    ...entity.deposito,
                    id: parceiro.id,
                    domain_id: entity.domain_id,
                    parceiro: undefined,
                    pre_deposito_id: precadastro.id
                  });
                })
              )
              .subscribe(
                () => {
                  this.matSnackBar.open('Depósito criado com sucesso.', 'X', {
                    duration: 2000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['msg-success']
                  });
                  this.dialogRef.close(precadastro);
                },
                (err: HttpErrorResponse) => this.displayError(err)
              );
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
      }
    } else this.insertPreCadastro(preCadastro);
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastDeposito.maximize();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
